import apiClient from "./apiClient.js";
import {setAlert} from "./alert";
import {Dispatch} from "redux";
import { IService, Server } from "@leap4/auth";
import {AlertTypes} from "../utils/alert.utils";



export const getAllServices = async (dispatch: Dispatch<any>) => {
    try {

        // Deserializtion.
        const res = await apiClient.get(`${Server.routes.SERVICES.GET_ALL.path}`);
        const services: IService[] = res.data;

        return services;
    } catch (err) {
        dispatch(setAlert("Error happened", AlertTypes.FAILURE));
    }
};



